import { render, staticRenderFns } from "./link.vue?vue&type=template&id=cc8082e4"
import script from "./link.vue?vue&type=script&lang=js"
export * from "./link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports